import { Button } from "@/components/ui/button";

export function MeetingLogoutButton({
  showLogout,
  loggingOut,
  onLogout,
}: {
  showLogout: boolean;
  loggingOut: boolean;
  onLogout: () => void;
}) {
  if (!showLogout) return null;

  return (
    <div className="absolute top-[max(1rem,env(safe-area-inset-top))] right-[max(1rem,env(safe-area-inset-right))] z-50">
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={loggingOut}
        onClick={onLogout}
        className="border-white/20 bg-black/60 text-white hover:bg-white/10 hover:text-white"
      >
        {loggingOut ? "Logging out…" : "Log out"}
      </Button>
    </div>
  );
}
